export const momentYMDHMS = (moment: moment.Moment): string =>
  moment.format('YYYY-MM-DD HH:mm:ss');
